import React from "react";
import { __ } from "@wordpress/i18n";
import { HeroSection } from "../components/hero";
import { Tabs, TabsMenu, TabPanel, TabsContent, Tab } from "../components/tabs";
import { Footer } from "../components/footer";
import { Highlights } from "../components/highlights";
import { FreeContent } from "./free";
import { ProContent } from "./pro";

const Wrapper = () => {
  return (
    <div className="wpmudev-cross-sell-page">
      <div className="sui-box">
        <div className="sui-box-body">
          <HeroSection />
          <Tabs>
            <TabsMenu>
              <Tab>
                {__(`Free Plugins you’ll like`, "plugin-cross-sell-textdomain")}
              </Tab>
              <Tab>
                {__(
                  `Pro Plugins You’ll LOVE (Bundle Deal)`,
                  "plugin-cross-sell-textdomain"
                )}
              </Tab>
            </TabsMenu>
            <TabsContent>
              <TabPanel>
                <FreeContent />
              </TabPanel>
              <TabPanel>
                <ProContent />
              </TabPanel>
            </TabsContent>
          </Tabs>
          <Highlights />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export { Wrapper };
